import { currentBreakpoint, viewport } from "../../../exports/viewport";
import { on } from "../../../exports/event";
import type { Breakpoint, BreakpointOptions, BreakpointUnknown } from "./types";
import { digestMessage } from "../utils/utils";
import type { Viewport } from "../../../exports/viewport";
import type { NexusHandler, NexusSignal } from "../../../exports/nexus";
import type { Unset } from "../../event/head";

export const defaults: BreakpointOptions = {
  s: window.matchMedia("(min-width: 0em) and (max-width: 27.99em)"),
  m: window.matchMedia("(min-width: 28em) and (max-width: 47.99em)"),
  l: window.matchMedia("(min-width: 48em) and (max-width: 61.99em)"),
  xl: window.matchMedia("(min-width: 62em)"),
};

/**
 *
 *
 *
 */
export const getListener =
  (bp: Breakpoint, signal: NexusSignal<Breakpoint | BreakpointUnknown | undefined>) =>
  /*                                                         */
  (query: MediaQueryListEvent) => {
    if (query.matches) signal.set(bp);
  };

/**
 *
 *
 *
 */
export const initializeBreakpointHandler = (
  options = defaults,
  signal: NexusSignal<Breakpoint | BreakpointUnknown | undefined> = currentBreakpoint,
): Unset[] =>
  Object.entries(options).map(([bp, query]) => on(query, "change", getListener(bp, signal)));

/**
 *
 */
export const getCurrentBreakpoint = ((options = defaults) =>
  Object.entries(options).find(([, query]) => query.matches)?.[0] ||
  "unknown") satisfies NexusHandler<Viewport["getCurrentBreakpoint"]>;

/**
 *
 */
export const isActiveBreakpoint = ((breakpointIds = [], options = defaults) =>
  !!breakpointIds.find((bp) => options[bp]?.matches)) satisfies NexusHandler<
  Viewport["isActiveBreakpoint"]
>;

/**
 *
 */
export const withBreakpoints = (async (options = defaults) => {
  const key = await digestMessage(
    Object.values(options)
      .map(({ media }) => media)
      .join(","),
  );

  const signal = viewport.__breakpoints[key];
  if (!signal.isReady) signal.assignStore(getCurrentBreakpoint(options));

  initializeBreakpointHandler(options, signal);

  return {
    current: signal,
    isActive: (breakpoints) => isActiveBreakpoint(breakpoints, options),
  };
}) satisfies NexusHandler<Viewport["withBreakpoints"]>;
